<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-row no-gutters class="ms-3" v-if="isView">
          <v-col>
            <v-tabs v-model="tab" height="64" background-color="transparent">
              <v-tab>
                <v-card-title class="pa-0">
                  {{ $t("CRUD.viewInfo", [$consts.shopName()]) }}
                </v-card-title>
              </v-tab>
              <v-tab v-if="$permission.permissionAllow('ShopAddress', 'view')">
                <v-card-title class="pa-0">
                  {{ $t("Shop.viewShopAddress", [$consts.shopName()]) }}
                </v-card-title>
              </v-tab>
              <v-tab v-if="settings && settings.shop_multiple_account">
                <v-card-title class="pa-0">
                  {{ $t("Shop.viewShopUsers", [$consts.shopName()]) }}
                </v-card-title>
              </v-tab>
              <v-tab v-if="settings && settings.service_charge_enable">
                <v-card-title class="pa-0">
                  {{ $t("Shop.service_charge_setting") }}
                </v-card-title>
              </v-tab>
              <v-tab v-if="$permission.permissionAllow('Shops', 'getAllianceBusinesses')">
                <v-card-title class="pa-0">
                  {{
                    $t("Shop.viewAllianceBusiness", [$consts.allianceName()])
                  }}
                </v-card-title>
              </v-tab>
               <v-tab>
                <v-card-title class="pa-0">
                  {{
                    $t("Shop.viewSockDistribution")
                  }}
                </v-card-title>
              </v-tab>
              <v-tab v-if="$permission.permissionAllow('Shops', 'getOrderRulers')">
                <v-card-title class="pa-0">
                  {{
                    $t("Shop.viewOrderRuler")
                  }}
                </v-card-title>
              </v-tab>
            </v-tabs>
          </v-col>
          <v-card-title class="me-3">
            <v-tooltip left class="me-1">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  @click="
                    $emit('mode', null);
                    $emit('input', null);
                  "
                  >fa-times
                </v-icon>
              </template>
              <span>
                {{ $t("CRUD.backToList", [$t("Material.ObjectName")]) }}
              </span>
            </v-tooltip>
          </v-card-title>
        </v-row>
        <v-card-title class="mx-3" v-else>
          {{
            $t(
              isNew
                ? "CRUD.newInfo"
                : savable
                ? "CRUD.editInfo"
                : "CRUD.viewInfo",
              [$consts.shopName()]
            )
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$consts.shopName()]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <ValidationObserver ref="observer">
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Shop.Fields.shop_code", [$consts.shopName()]) +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.Fields.shop_code', [$consts.shopName()])"
                      rules="required"
                    >
                      <v-text-field
                        single-line
                        v-model="shop.shop_code"
                        :hint="
                          isNew ? '' : $t('Shop.codeHint', [$consts.shopName()])
                        "
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'shop_code')
                            .concat(errors)
                        "
                        :disabled="!!sync_shop_data_from"
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ shop.shop_code }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Shop.Fields.shop_name", [$consts.shopName()]) +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.Fields.shop_name', [$consts.shopName()])"
                      rules="required"
                    >
                      <v-text-field
                        single-line
                        v-model="shop.shop_name"
                        :hint="
                          isNew ? '' : $t('Shop.nameHint', [$consts.shopName()])
                        "
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'shop_name')
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ shop.shop_name }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Shop.Fields.avatar_img") + $t("Global.colon") }}
                  </v-col>
                  <v-col cols="9" md="7">
                    <v-card v-if="avatar_img" max-width="240">
                      <v-img
                        :src="avatar_img"
                        @click.stop="$showFullscreenImages([avatar_img])"
                      >
                        <v-tooltip right v-if="savable && avatar_img">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              color="danger"
                              class="pa-2 float-right"
                              @click.stop="
                                !avatar_img.startsWith('data:image/') &&
                                avatar_img == shop.avatar_img_url
                                  ? (shop.avatar_img = avatar_img = null)
                                  : (avatar_img = null)
                              "
                            >
                              fa-times
                            </v-icon>
                          </template>
                          <span> {{ $t("Material.delImg") }}</span>
                        </v-tooltip>
                      </v-img>
                    </v-card>
                    <v-file-input
                      ref="avatar_img_file"
                      v-if="savable"
                      show-size
                      prepend-icon="fa-camera"
                      accept="image/png, image/jpeg"
                      persistent-hint
                      :placeholder="$t('Material.imgPlaceholder')"
                      :hint="$t('Material.imgSquareHint')"
                      :rules="imgRules"
                      v-model="avatar_img_file"
                    >
                    </v-file-input>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Shop.Fields.company_name") + $t("Global.colon") }}
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field single-line v-model="shop.company_name">
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ shop.company_name }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Shop.Fields.national_tax_code") + $t("Global.colon")
                    }}
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field single-line v-model="shop.national_tax_code">
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ shop.national_tax_code }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Shop.Fields.shop_district") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.Fields.shop_district')"
                      rules="required"
                    >
                      <SearcherDistrict
                        v-model="shop.district"
                        no-label
                        unclearable
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'city_1')
                            .concat(errors)
                        "
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ shop && shop.district ? shop.district.name : "" }}
                  </v-col>
                </v-row>
                <v-row
                  align="center"
                  v-if="settings && settings.shop_inventory_enable"
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Shop.Fields.label", [this.$consts.shopName()]) +
                      $t("Global.colon")
                    }}
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-combobox
                      ref="label"
                      v-model="shop.label"
                      :items="labels"
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ shop.label }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="3"
                    :class="
                      savable
                        ? 'font-weight-bold text-right mt-8'
                        : 'font-weight-bold text-right'
                    "
                  >
                    {{
                      $t("Shop.Fields.shop_address", [$consts.shopName()]) +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <!-- 三级地址 -->
                    <CitiesSelectGroup
                      :masterItem="shop"
                      @provinceSelected="shop.province_id = $event.id"
                      @citySelected="shop.city_id = $event.id"
                      @districtSelected="shop.area_id = $event.id"
                    />
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="
                        $t('Shop.Fields.shop_address', [$consts.shopName()])
                      "
                      rules="required"
                    >
                      <v-text-field
                        single-line
                        v-model="shop.address"
                        :label="
                          $t('Shop.Fields.shop_address', [$consts.shopName()])
                        "
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'address')
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <!-- 三级地址 -->
                    <AddressText
                      :masterItem="shop"
                      :detailAddress="shop.address"
                    />
                    <v-btn
                      v-show="
                        !savable &&
                        shop &&
                        shop.address &&
                        $permission.permissionAllow('ShopAddress', 'view')
                      "
                      class="ml-5"
                      color="primary"
                      x-small
                      @click.stop="syncAddress()"
                    >
                      {{ $t("Shop.Fields.sync_address") }}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Shop.Fields.template") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-autocomplete
                      color="primary"
                      hide-no-data
                      v-model="materialTemplate"
                      :items="templatesItems"
                      :loading="templatesLoading"
                      :search-input.sync="templatesSearch"
                      item-text="template_name"
                      item-value="id"
                      item-disabled="disabled"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <a :href="'/#/templates/' + shop.material_template_id">
                      {{ shop.template_name }}
                    </a>
                  </v-col>
                </v-row>
                <!-- 预售模板 -->
                <v-row
                  align="center"
                  v-if="
                    $permission.permissionAllow('PresaleTemplates', 'index') &&
                    settings &&
                    settings.presale_enable
                  "
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Shop.Fields.presellTemplate") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-autocomplete
                      color="primary"
                      hide-no-data
                      v-model="presellTemplate"
                      :items="presellTemplatesItems"
                      :loading="presellTemplatesLoading"
                      :search-input.sync="presellTemplatesSearch"
                      item-text="template_name"
                      item-value="id"
                      item-disabled="disabled"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <a
                      :href="'#/pre-sell/' + shop.presale_template_id + '/edit'"
                    >
                      {{
                        shop.presale_template
                          ? shop.presale_template.template_name
                          : ""
                      }}
                    </a>
                  </v-col>
                </v-row>
                <v-row
                  align="center"
                  v-if="settings && settings.use_ordercycle"
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Shop.Fields.order_cycle_setting") + $t("Global.colon")
                    }}
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-select
                      v-model="shop.order_cycles_code"
                      :items="orderCycles"
                      item-text="name"
                      item-value="code"
                      clearable
                    ></v-select>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{
                      shop && shop.order_cycle
                        ? shop.order_cycle.name
                        : $t("CRUD.unsetting")
                    }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Shop.Fields.pay_setting") + $t("Global.colon") }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-select
                      v-model="shop.shop_pay_setting"
                      :items="paySettings"
                      item-text="text"
                      item-value="value"
                      dense
                    ></v-select>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ shop.shop_pay_setting | shopPaySettingsText }}
                  </v-col>
                </v-row>
                <v-row
                  align="center"
                  v-if="
                    shop.shop_pay_setting == 3 ||
                    ($permission.permissionAllow('Shops', 'shopBillDate') &&
                      shop.shop_pay_setting == 7)
                  "
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Shop.Fields.shop_bail") + $t("Global.colon") }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.Fields.shop_bail')"
                      :rules="{
                        min_value: {
                          min: 0.01,
                        },
                      }"
                    >
                      <v-text-field
                        single-line
                        v-model="shop.shop_bail"
                        type="number"
                        :prefix="$t('Global.money')"
                        :error-messages="errors"
                        @blur="
                          shop.shop_bail =
                            shop.shop_bail < 0.01
                              ? shop.shop_bail
                              : $numberFormatter.formatMoneyFloor(
                                  shop.shop_bail
                                )
                        "
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ $t("Global.money") }}{{ shop.shop_bail | formatMoney }}
                  </v-col>
                </v-row>
                <v-row
                  align="center"
                  v-if="
                    $permission.permissionAllow('Shops', 'shopBillDate') &&
                    (shop.shop_pay_setting == 5 ||
                      shop.shop_pay_setting == 6 ||
                      shop.shop_pay_setting == 7)
                  "
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Shop.Fields.bill_days") + $t("Global.colon") }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.Fields.bill_days')"
                      :rules="{
                        min_value: { min: 1 },
                        required: { required: true },
                      }"
                    >
                      <v-text-field
                        single-line
                        v-model="shop.bill_days"
                        type="number"
                        :error-messages="errors"
                        @blur="
                          shop.bill_days =
                            shop.bill_days <= 0
                              ? 1
                              : $numberFormatter.formatNoDot(shop.bill_days)
                        "
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ shop.bill_days }}
                  </v-col>
                </v-row>
                <v-row
                  align="center"
                  v-if="this.settings && this.settings.sub_account_enable == 2"
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("SubAccount.title") + $t("Global.colon") }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <SearcherSubAccount v-model="shop.shop_sub_account_id" />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ shop_sub_account_name }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Shop.Fields.status") + $t("Global.colon") }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-radio-group row v-model="shop.status">
                      <v-radio
                        v-for="stat in status"
                        :key="stat.value"
                        :label="`${stat.text}`"
                        :value="stat.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <v-chip color="primary" small label>
                      {{ shop.status | shopStatusText }}
                    </v-chip>
                  </v-col>
                </v-row>
                <v-row
                  align="center"
                  v-if="settings && settings.shop_inventory_enable"
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Shop.Fields.psi_setting", [$consts.shopName()]) +
                      $t("Global.colon")
                    }}
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable && shop.old_psi_enable">
                    <v-checkbox
                      v-model="shop.psi_enable"
                      color="primary"
                      :value="1"
                      :true-value="1"
                      :false-value="0"
                    >
                      <template v-slot:label>
                        <span class="caption ms-n2">
                          {{
                            $t(
                              shop.psi_enable
                                ? "Shop.psiSettings.on"
                                : "Shop.psiSettings.off"
                            )
                          }}
                        </span>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col
                    cols="9"
                    md="7"
                    v-else-if="savable && !shop.old_psi_enable"
                  >
                    <v-checkbox
                      color="primary"
                      v-model="shop.psi_enable"
                      :true-value="1"
                      :false-value="0"
                      @click.stop="checkShopPsiOpenFromAPI()"
                    >
                      <template v-slot:label>
                        <span class="caption ms-n2">
                          {{
                            $t(
                              shop.psi_enable
                                ? "Shop.psiSettings.on"
                                : "Shop.psiSettings.off"
                            )
                          }}
                        </span>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <v-chip color="primary" small label>
                      {{
                        $t(
                          shop.psi_enable
                            ? "Shop.psiSettings.on"
                            : "Shop.psiSettings.off"
                        )
                      }}
                    </v-chip>
                  </v-col>
                </v-row>
                <v-row
                  align="center"
                  v-if="
                    settings &&
                    settings.shop_inventory_enable &&
                    !savable &&
                    shop.old_psi_enable
                  "
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Shop.Fields.psi_date", [$consts.shopName()]) +
                      $t("Global.colon")
                    }}
                  </v-col>
                  <v-col cols="9" md="7">
                    {{ shop.psi_start | formatDate }} ~
                    {{ shop.psi_end | formatDate }}
                  </v-col>
                </v-row>
                <v-row
                  align="center"
                  v-if="
                    settings &&
                    settings.push_platform == 2001 &&
                    ($permission.permissionAllow('SubAccountConfigs', 'edit') ||
                      $permission.permissionAllow('SubAccountConfigs', 'view'))
                  "
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Shop.Fields.sub_account_setting") + $t("Global.colon")
                    }}
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <a @click="editSubAccountPercentDialog = true">
                      {{ $t("CRUD.setting", [""]) }}
                    </a>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <a @click="editSubAccountPercentDialog = true">
                      {{ $t("CRUD.read") }}
                    </a>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Shop.Fields.memo") + $t("Global.colon") }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-textarea outlined v-model="shop.comment"></v-textarea>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ shop.comment }}
                  </v-col>
                </v-row>
                <v-row align="center" v-if="settings && settings.shop_contract">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Shop.Fields.contract_period") + $t("Global.colon") }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <SearcherDatetimeRange
                      v-if="savable"
                      class="my-n2"
                      v-model="contract_period"
                      type="date"
                      single-line
                      dense
                      hide-details
                      hide-icon
                      hide-shortcuts
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ shop.contract_start }} ~ {{ shop.contract_end }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Shop.Fields.shop_user_name") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.Fields.shop_user_name')"
                      rules="required"
                    >
                      <v-text-field
                        single-line
                        v-model="shop_user.name"
                        :hint="
                          isNew
                            ? ''
                            : $t('Shop.loginUserNameHint', [$consts.shopName()])
                        "
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'shop_user.name')
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ shop && shop.shop_user ? shop.shop_user.name : "" }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Shop.Fields.identification_num") + $t("Global.colon")
                    }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field
                      v-model="shop_user.identification_num"
                      single-line
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{
                      shop && shop.shop_user
                        ? shop.shop_user.identification_num
                        : ""
                    }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Shop.Fields.shop_user_tel") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.Fields.shop_user_tel')"
                      :rules="{ required: true, regex: '^.{6,11}$' }"
                    >
                      <v-text-field
                        v-model="shop_user.tel"
                        single-line
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'shop_user.tel')
                            .concat(errors)
                        "
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ shop && shop.shop_user ? shop.shop_user.tel : "" }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Shop.Fields.ext_shop_code") + $t("Global.colon") }}
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field single-line v-model="shop_user.ext_code">
                    </v-text-field>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ shop && shop.shop_user ? shop.shop_user.ext_code : "" }}
                  </v-col>
                </v-row>
                <v-row
                  align="center"
                  v-if="settings && settings.shop_third_account"
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Shop.Fields.third_account_number") +
                      $t("Global.colon")
                    }}
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field
                      single-line
                      v-model="shop.third_account_number"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ shop ? shop.third_account_number : "" }}
                  </v-col>
                </v-row>
                <v-row
                  align="center"
                  v-if="settings && settings.shop_third_account"
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Shop.Fields.third_stock_number") + $t("Global.colon")
                    }}
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field single-line v-model="shop.third_stock_number">
                    </v-text-field>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ shop ? shop.third_stock_number : "" }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Shop.Fields.login_user_id") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.Fields.login_user_id')"
                      rules="required|min:6"
                    >
                      <v-text-field
                        single-line
                        v-model="shop_user.login_user_id"
                        :hint="
                          isNew
                            ? ''
                            : $t('Shop.loginUserNameHint', [$consts.shopName()])
                        "
                        :error-messages="
                          $resparse
                            .getErrorMsgs(
                              serverErrors,
                              'shop_user.login_user_id'
                            )
                            .concat(errors)
                        "
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{
                      shop && shop.shop_user ? shop.shop_user.login_user_id : ""
                    }}
                  </v-col>
                </v-row>
                <v-row align="center" v-if="savable && isNew">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Shop.Fields.login_user_password") + $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.Fields.login_user_password')"
                      rules="required|min:6"
                    >
                      <v-text-field
                        single-line
                        v-model="shop_user.password"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'shop_user.password')
                            .concat(errors)
                        "
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row align="center" v-else-if="savable && !isNew">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Shop.Fields.login_user_password") + $t("Global.colon")
                    }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.Fields.login_user_password')"
                      rules="min:6"
                    >
                      <v-text-field
                        single-line
                        v-model="shop_user.password"
                        :hint="
                          isNew
                            ? ''
                            : $t('Shop.loginPasswordHint', [$consts.shopName()])
                        "
                        :error-messages="errors"
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row align="center" v-if="isView">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Shop.Fields.recommend_name") + $t("Global.colon") }}
                  </v-col>
                  <v-col cols="9" md="7">
                    {{
                      shop && shop.recommend_name
                        ? shop.recommend_name + "(" + shop.recommend_code + ")"
                        : ""
                    }}
                  </v-col>
                </v-row>
                <v-row align="center" v-if="isView">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Shop.Fields.weQr") + $t("Global.colon") }}
                  </v-col>
                  <v-col cols="9" md="7">
                    <v-img
                      max-width="140"
                      :src="shop.weQrCode_url"
                      @click.stop="$showFullscreenImages([shop.weQrCode_url])"
                    >
                    </v-img>
                  </v-col>
                </v-row>
              </ValidationObserver>
            </v-tab-item>
            <v-tab-item
              v-if="$permission.permissionAllow('ShopAddress', 'view')"
            >
              <v-data-table
                :headers="headers"
                :items="shopAddresses"
                :loading="loading"
                multi-sort
                :footer-props="$t('$config.footer-props')"
              >
                <template v-slot:header.actions="{ header }">
                  {{ header.text }}
                  <v-icon x-small>fa-sliders-h</v-icon>
                </template>

                <template v-slot:item.province="{ item }">
                  {{ citiesMap ? citiesMap[item.province] : "" }}
                </template>
                <template v-slot:item.city="{ item }">
                  {{ citiesMap ? citiesMap[item.city] : "" }}
                </template>
                <template v-slot:item.area="{ item }">
                  {{ citiesMap ? citiesMap[item.area] : "" }}
                </template>
                <template v-slot:item.default_flg="{ item }">
                  <div class="d-flex mt-n2 mb-n3">
                    <v-checkbox
                      v-model="item.default_flg"
                      :true-value="1"
                      :false-value="0"
                      :disabled="item.default_flg == 1"
                      @click.stop="changeDefaultAddress(item)"
                    ></v-checkbox>
                  </div>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-tooltip
                    top
                    v-if="$permission.permissionAllow('ShopAddress', 'edit')"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        class="px-1 py-4 me-1"
                        @click.stop="
                          currentItem = Object.assign({}, item, {
                            province_id: item.province,
                            city_id: item.city,
                            area_id: item.area,
                            org_default_flg: item.default_flg,
                          });
                          editDialog = true;
                        "
                        >fa-pencil-alt
                      </v-icon>
                    </template>
                    <span>{{
                      $t("CRUD.editInfo", [
                        $t("Shop.shopAddress", [$consts.shopName()]),
                      ])
                    }}</span>
                  </v-tooltip>
                  <v-tooltip
                    top
                    v-if="
                      !item.default_flg &&
                      $permission.permissionAllow('ShopAddress', 'delete')
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="danger"
                        class="px-1 me-1"
                        @click.stop="
                          currentItem = item;
                          deleteDialog = true;
                        "
                        >fa-trash-alt
                      </v-icon>
                    </template>
                    <span>{{
                      $t("CRUD.deleteInfo", [
                        $t("Shop.shopAddress", [$consts.shopName()]),
                      ])
                    }}</span>
                  </v-tooltip>
                </template>

                <template v-slot:body.append>
                  <tr>
                    <td colspan="8">
                      <v-btn
                        v-if="$permission.permissionAllow('ShopAddress', 'add')"
                        small
                        color="primary"
                        @click.stop="
                          currentItem = { id: 0, shop_id: value.id };
                          editDialog = true;
                        "
                        class="ms-1"
                      >
                        <v-icon x-small class="pe-1">fa-plus</v-icon>
                        {{
                          $t("CRUD.newInfo", [
                            $t("Shop.shopAddress", [$consts.shopName()]),
                          ])
                        }}
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item v-if="settings && settings.shop_multiple_account">
              <v-data-table
                :headers="userHeaders"
                :items="shopUsers"
                :loading="loading"
                multi-sort
                :footer-props="$t('$config.footer-props')"
              >
                <template v-slot:header.actions="{ header }">
                  {{ header.text }}
                  <v-icon x-small>fa-sliders-h</v-icon>
                </template>

                <template v-slot:item.role="{ item }">
                  {{
                    item.role == 1
                      ? $t("Shop.Fields.shop_user_role_1")
                      : $t("Shop.Fields.shop_user_role_2")
                  }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-tooltip
                    top
                    v-if="
                      settings &&
                      settings.shop_multiple_account &&
                      item.role != 1
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        class="px-1 py-4 me-1"
                        @click.stop="
                          currentUserItem = Object.assign({}, item);
                          editUserDialog = true;
                        "
                        >fa-pencil-alt
                      </v-icon>
                    </template>
                    <span>{{
                      $t("CRUD.editInfo", [
                        $t("Shop.shopUsers", [$consts.shopName()]),
                      ])
                    }}</span>
                  </v-tooltip>
                  <v-tooltip
                    top
                    v-if="
                      settings &&
                      settings.shop_multiple_account &&
                      item.role != 1
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="danger"
                        class="px-1 me-1"
                        @click.stop="
                          currentUserItem = item;
                          deleteUserDialog = true;
                        "
                        >fa-trash-alt
                      </v-icon>
                    </template>
                    <span>{{
                      $t("CRUD.deleteInfo", [
                        $t("Shop.shopUsers", [$consts.shopName()]),
                      ])
                    }}</span>
                  </v-tooltip>
                </template>

                <template v-slot:body.append>
                  <tr>
                    <td colspan="8">
                      <v-btn
                        v-if="settings && settings.shop_multiple_account"
                        small
                        color="primary"
                        @click.stop="
                          currentUserItem = { id: 0, shop_id: value.id };
                          editUserDialog = true;
                        "
                        class="ms-1"
                      >
                        <v-icon x-small class="pe-1">fa-plus</v-icon>
                        {{
                          $t("CRUD.newInfo", [
                            $t("Shop.shopUsers", [$consts.shopName()]),
                          ])
                        }}
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item v-if="settings && settings.service_charge_enable">
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  <div class="mt-5">
                    {{ $t("Shop.service_charge_type") + $t("Global.colon") }}
                  </div>
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group
                    row
                    v-model="service_charge_type"
                    @change="alertDialog = true"
                  >
                    <v-radio
                      v-for="type in types"
                      :key="type.value"
                      :label="`${type.text}`"
                      :value="type.value"
                    ></v-radio>
                  </v-radio-group>
                  <v-btn
                    v-if="service_charge_type == 2"
                    color="primary"
                    class="my-1 mr-3"
                    outlined
                    @click="materials_dialog = true"
                  >
                    {{ $t("Shop.chooseMaterial") }}
                  </v-btn>
                  <v-data-table
                    v-if="service_charge_type == 2"
                    :headers="materialHeaders"
                    :items="freeMaterials"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    fixed-header
                    :footer-props="$t('$config.footer-props')"
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          districts_one.splice(
                            districts_one.findIndex(
                              (district) => district.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item v-if="$permission.permissionAllow('Shops', 'getAllianceBusinesses')">
              <v-data-table
                :headers="allianceBusinessHeaders"
                :items="allianceBusinessShops"
                :loading="loading"
                multi-sort
                fixed-header
                :footer-props="$t('$config.footer-props')"
              >
              </v-data-table>
            </v-tab-item>
            <v-tab-item>
              <v-data-table
                :headers="stockDistributionHeaders"
                :items="stockDistributionConfigs"
                :options.sync="stockDistributionOptions"
                :page.sync="stockDistributionPaging.page"
                :server-items-length="stockDistributionPaging.count"
                :loading="loading"
                multi-sort
                fixed-header
                :footer-props="$t('$config.footer-props')"
              >
                <template v-slot:item.stock_type="{ item }">
                    <v-chip v-if="item.stock_type == 0" small label>
                      {{ $t("Stock.type.real") }}
                    </v-chip>
                    <v-chip v-if="item.stock_type == 1" small label>
                      {{ $t("Stock.type.v_auto") }}
                    </v-chip>
                    <v-chip v-if="item.stock_type == 2" small label>
                      {{ $t("Stock.type.v_manual") }}
                    </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          small
                          dark
                          color="primary"
                          class="px-2 me-2 mb-1"
                          @click.stop="
                            materialsDialog = true;
                            shopId = shop.id;
                            stockId = item.stock_id;
                          "
                        >
                          {{ $t("Shop.Fields.view_material") }}
                        </v-btn>
                      </template>
                        <span> {{ $t("Shop.Fields.view_material") }}</span>
                    </v-tooltip>
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item  v-if="$permission.permissionAllow('Shops', 'getOrderRulers')">
              <v-data-table
                :headers="orderRulerHeaders"
                :items="orderRulers"
                :loading="loading"
                multi-sort
                fixed-header
                :footer-props="$t('$config.footer-props')"
              >
                <template v-slot:item.type="{ item }">
                  {{ getOrderRulerType(item.type) }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          v-bind="attrs"
                          v-on="on"
                          small
                          dark
                          color="primary"
                          class="px-2 me-2 mb-1"
                          @click.stop="
                            $permission.checkAccountExpired().then(() => {
                              $router.push({
                                path:
                                  getOrderRulerDetailUrl(item.type) + item.id,
                                query: { type: item.type, mode: 'view' },
                              });
                            })
                          "
                      >
                        {{ $t("Shop.Fields.view_order_ruler") }}
                      </v-btn>
                    </template>
                    <span> {{ $t("Shop.Fields.view_order_ruler") }}</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="
                    $emit('input', null);
                    $emit('mode', null);
                  "
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backToList", [$consts.shopName()]) }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="isView && $permission.permissionAllow('Shops', 'edit')"
              >
                <v-btn
                  color="accent"
                  block
                  :disabled="loading && !shop.id"
                  @click="$emit('mode', 'edit')"
                >
                  <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                  {{ $t("CRUD.editInfo", [$consts.shopName()]) }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  savable &&
                  $permission.permissionAllow('Shops', isNew ? 'add' : 'edit')
                "
              >
                <v-btn
                  color="success"
                  block
                  :disabled="loading && !shop.id"
                  @click="submit()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.saveInfo", [$consts.shopName()]) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
        <v-card class="mt-4 d-none" v-if="isView">
          <template>
            <v-simple-table
              fixed-header
              style="max-height: 200px; min-height: 80px"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">{{ $t("Shop.deviceModel") }}</th>
                    <th class="text-center">
                      {{ $t("TableHeaders.actions") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="data in testData" :key="data.id">
                    <td>{{ data.name }}</td>
                    <td>
                      <v-col
                        ><v-btn class="primary" block x-small
                          >解绑</v-btn
                        ></v-col
                      >
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </template>
        </v-card>
        <v-card class="mt-4" v-if="isView">
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn outlined color="primary" class="elevation-1" block>
                  {{ $t("Shop.newValidation") }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  settings &&
                  settings.shop_inventory_enable &&
                  shop.psi_enable &&
                  $permission.permissionAllow('Shops', 'shopPsiDetail')
                "
              >
                <v-btn
                  block
                  outlined
                  color="primary"
                  class="elevation-1"
                  :disabled="loading && !shop.id"
                  target="_blank"
                  :href="shopPsiUrl"
                >
                  {{ $t("Shop.openShopPsi") }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  settings &&
                  settings.shop_inventory_enable &&
                  shop.actions &&
                  shop.actions.editPsiLifespan &&
                  $permission.permissionAllow('Shops', isNew ? 'add' : 'edit')
                "
              >
                <v-btn
                  block
                  outlined
                  color="primary"
                  class="elevation-1"
                  :disabled="loading && !shop.id"
                  @click.stop="addPsiDateDialog = true"
                >
                  {{ $t("Shop.addPsiDate") }}
                </v-btn>
              </v-col>
              <v-col cols="12" v-if="shop.actions && shop.actions.queryCbkInfo">
                <v-btn
                  outlined
                  color="primary"
                  class="elevation-1"
                  block
                  @click.stop="queryAccountInfo()"
                >
                  {{ $t("Shop.queryCbkInfo") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>

    <DialogAlert
      v-model="settingDefaultAddressDialog"
      :message="settingDefaultAddressMsg"
      useConfirm
      @close="
        settingDefaultAddressDetail.default_flg =
          settingDefaultAddressDetail.default_flg ? 0 : 1
      "
      @confirm="settingDefaultAddress()"
    />
    <v-dialog persistent v-model="addPsiDateDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{
            $t("Shop.addPsiDate", [$consts.shopName()])
          }}</span>

          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="addPsiDateDialog = false"
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.back", []) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="psiObserver">
              <v-form>
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.addPsiDate')"
                      :rules="{ required: true, regex: '^[1-9]\\d*$' }"
                    >
                      <v-text-field
                        type="number"
                        v-model="addPsiDate"
                        :label="$t('Shop.addPsiDate')"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(addPsiDateErrors, 'lifespan_days')
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="addPsiDateDialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="saveAddPsiDate()">{{
            $t("CRUD.save")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="editDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{
            $t("Shop.shopAddress", [$consts.shopName()])
          }}</span>

          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="editDialog = false"
                >fa-times
              </v-icon>
            </template>
            <span>
              {{
                $t("CRUD.backToList", [
                  $t("Shop.shopAddress", [$consts.shopName()]),
                ])
              }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="addressObserver">
              <v-form>
                <v-row>
                  <v-col cols="12">
                    <!-- 三级地址 -->
                    <CitiesSelectGroup
                      :masterItem="currentItem"
                      @provinceSelected="
                        currentItem.province = currentItem.province_id =
                          $event.id
                      "
                      @citySelected="
                        currentItem.city = currentItem.city_id = $event.id
                      "
                      @districtSelected="
                        currentItem.area = currentItem.area_id = $event.id
                      "
                    />
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.Fields.shop_receiving_address')"
                      rules="required"
                    >
                      <v-text-field
                        v-model="currentItem.address"
                        :label="$t('Shop.Fields.shop_receiving_address')"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(addressServerErrors, 'address')
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.Fields.shop_address_name')"
                      rules="required"
                    >
                      <v-text-field
                        v-model="currentItem.name"
                        :label="$t('Shop.Fields.shop_address_name')"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(addressServerErrors, 'name')
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.Fields.shop_user_tel')"
                      :rules="{ required: true, regex: '^.{6,11}$' }"
                    >
                      <v-text-field
                        v-model="currentItem.phone"
                        :label="$t('Shop.Fields.shop_user_tel')"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(addressServerErrors, 'phone')
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <div class="d-flex mt-n3 mb-n3">
                      <v-checkbox
                        v-model="currentItem.default_flg"
                        :label="$t('Shop.Fields.shop_default_address')"
                        :true-value="1"
                        :false-value="0"
                        :disabled="currentItem.org_default_flg == 1"
                      ></v-checkbox>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="editDialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="saveShopAddress()">{{
            $t("CRUD.save")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="editUserDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline"
            >{{ $t("Shop.shopUsers", [$consts.shopName()]) }}
            -
            {{
              currentUserItem.role == 1
                ? $t("Shop.Fields.shop_user_role_1")
                : $t("Shop.Fields.shop_user_role_2")
            }}</span
          >

          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="editUserDialog = false"
                >fa-times
              </v-icon>
            </template>
            <span>
              {{
                $t("CRUD.backToList", [
                  $t("Shop.shopUsers", [$consts.shopName()]),
                ])
              }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="userObserver">
              <v-form>
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.Fields.login_user_id')"
                      rules="required"
                    >
                      <v-text-field
                        v-model="currentUserItem.login_user_id"
                        :label="$t('Shop.Fields.login_user_id')"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(userServerErrors, 'login_user_id')
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.Fields.login_user_password')"
                      rules="required"
                    >
                      <v-text-field
                        v-model="currentUserItem.password"
                        :label="$t('Shop.Fields.login_user_password')"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(
                              userServerErrors,
                              'login_user_password'
                            )
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="currentUserItem.ext_code"
                      :label="$t('Shop.Fields.ext_shop_user_code')"
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.Fields.shop_user_name')"
                      rules="required"
                    >
                      <v-text-field
                        v-model="currentUserItem.name"
                        :label="$t('Shop.Fields.shop_user_name')"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(userServerErrors, 'shop_user_name')
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Shop.Fields.shop_user_tel')"
                      rules="required"
                    >
                      <v-text-field
                        v-model="currentUserItem.tel"
                        :label="$t('Shop.Fields.shop_user_tel')"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(userServerErrors, 'shop_user_tel')
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="editUserDialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="saveShopUser()">{{
            $t("CRUD.save")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('Shop.shopAddress', [$consts.shopName()])"
      @confirm="
        deleteShopAddress();
        deleteDialog = false;
      "
    />
    <DialogDelete
      v-model="deleteUserDialog"
      :label="$t('Shop.shopUsers', [$consts.shopName()])"
      @confirm="
        deleteShopUser();
        deleteUserDialog = false;
      "
    />
    <SubAccountConfigsDialog
      v-model="editSubAccountPercentDialog"
      :subAccoutSettings="sub_account_arr"
      :isView="isView"
      @confirm="sub_account_arr = $event"
    />
    <stockDistributionConfigsMaterialsDialog
      v-model="materialsDialog"
      :shopId ="shopId"
      :stockId ="stockId"
    />
    <MaterialsSelectsDialog
      v-model="materials_dialog"
      :materialIds="
        freeMaterials.length ? freeMaterials.map((detail) => detail.id) : []
      "
      @confirm="saveServiceChargeSetting($event)"
    />
    <DialogAlert
      v-model="alertDialog"
      :message="$t('Shop.serviceAlert')"
      useConfirm
      @confirm="
        service_charge_type == 2
          ? saveServiceChargeSetting(freeMaterials)
          : saveServiceChargeSetting()
      "
    />
    <v-dialog v-model="Dialog" width="600px">
      <v-card>
        <v-card-title> </v-card-title>
        <v-card-text v-model="dataItem">
          <JsonViewer :value="dataItem" expanded />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import consts from "@/consts";
import Required from "@/components/plugins/Required";
import SearcherDatetimeRange from "@/components/plugins/SearcherDatetimeRange";
import Shops from "@/api/shops";
import ShopAddress from "@/api/shop_address";
import Payment from "@/api/payment";
import ShopUsers from "@/api/shop_users";
import OrderCycles from "@/api/order_cycles";
import SubAccountSettings from "@/api/sub_account_settings";
import SearcherDistrict from "@/components/plugins/SearcherDistrict";
import Consts from "@/consts.js";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import CitiesSelectGroup from "@/components/plugins/CitiesSelects";
import AddressText from "@/components/plugins/AddressText";
import DialogAlert from "@/components/plugins/DialogAlert";
import DialogDelete from "@/components/plugins/DialogDelete";
import SubAccountConfigsDialog from "./SubAccountConfigsDialog";
import stockDistributionConfigsMaterialsDialog from "./stockDistributionConfigsMaterialsDialog";
import Templates from "@/api/templates";
import SearcherSubAccount from "@/components/plugins/SearcherSubAccount";
import SubAccounts from "@/api/sub_accounts";
import Files from "@/api/files";
import MaterialsSelectsDialog from "./MaterialsSelectsDialog";
import PresaleTemplates from "@/api/presale_templates";
import JsonViewer from "vue-json-viewer";

export default {
  name: "ShopDetail",

  props: ["value", "mode"],

  components: {
    Required,
    SearcherDatetimeRange,
    SearcherDistrict,
    ValidationObserver,
    ValidationProvider,
    // SearcherTemplate,
    CitiesSelectGroup,
    AddressText,
    DialogAlert,
    DialogDelete,
    SubAccountConfigsDialog,
    SearcherSubAccount,
    MaterialsSelectsDialog,
    JsonViewer,
    stockDistributionConfigsMaterialsDialog,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isNew() {
      return this.mode == "new";
    },
    paySettings() {
      let settings = Consts.shop.pay_settings.filter(
        (element) =>
          element.value != 5 && element.value != 6 && element.value != 7
      );
      if (this.$permission.permissionAllow("Shops", "shopBillDate")) {
        settings = Consts.shop.pay_settings;
      }
      return settings;
    },
    status() {
      return Consts.shop.status;
    },
    types: () => [
      {
        text: i18n.t("Shop.types.template"),
        value: 0,
      },
      {
        text: i18n.t("Shop.types.free"),
        value: 1,
      },
      {
        text: i18n.t("Shop.types.partFree"),
        value: 2,
      },
    ],
    materialHeaders: () => [
      {
        text: i18n.t("Material.Fields.material_code"),
        align: "start",
        sortable: true,
        value: "material_code",
      },
      {
        text: i18n.t("Material.Fields.material_name"),
        align: "start",
        sortable: true,
        value: "material_name",
      },
    ],
    headers: () => [
      {
        text: i18n.t("Area.city_1"),
        align: "start",
        sortable: true,
        value: "province",
      },
      {
        text: i18n.t("Area.city_2"),
        align: "start",
        sortable: true,
        value: "city",
      },
      {
        text: i18n.t("Area.city_3"),
        align: "start",
        sortable: true,
        value: "area",
      },
      {
        text: i18n.t("Shop.Fields.shop_receiving_address", [consts.shopName()]),
        align: "start",
        sortable: true,
        value: "address",
      },
      {
        text: i18n.t("Shop.Fields.shop_address_name"),
        align: "start",
        sortable: true,
        value: "name",
      },
      {
        text: i18n.t("Shop.Fields.shop_user_tel"),
        align: "start",
        sortable: true,
        value: "phone",
      },
      {
        text: i18n.t("Shop.Fields.shop_default_address"),
        align: "start",
        sortable: true,
        value: "default_flg",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        class: "text-no-wrap",
        sortable: false,
        value: "actions",
      },
    ],
    userHeaders: () => [
      {
        text: i18n.t("Shop.Fields.shop_user_role"),
        align: "start",
        sortable: true,
        value: "role",
      },
      {
        text: i18n.t("Shop.Fields.login_user_id"),
        align: "start",
        sortable: true,
        value: "login_user_id",
      },
      {
        text: i18n.t("Shop.Fields.ext_shop_user_code"),
        align: "start",
        sortable: true,
        value: "ext_code",
      },
      {
        text: i18n.t("Shop.Fields.shop_user_name"),
        align: "start",
        sortable: true,
        value: "name",
      },
      {
        text: i18n.t("Shop.Fields.shop_user_tel"),
        align: "start",
        sortable: true,
        value: "tel",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        class: "text-no-wrap",
        sortable: false,
        value: "actions",
      },
    ],
    allianceBusinessHeaders() {
      return [
        {
          text: i18n.t("Alliances.Fields.alliance_business_code", [
            this.$consts.allianceName(),
          ]),
          align: "start",
          sortable: false,
          value: "alliance_busines.alliance_business_code",
        },
        {
          text: i18n.t("Alliances.Fields.alliance_business_name", [
            this.$consts.allianceName(),
          ]),
          align: "start",
          sortable: false,
          value: "alliance_busines.alliance_business_name",
        },
        {
          text: i18n.t("Alliances.Fields.alliance_user_name"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "alliance_busines.account_user.name",
        },
        {
          text: i18n.t("Alliances.Fields.tel"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "alliance_busines.account_user.mobile",
        },
      ];
    },
    stockDistributionHeaders() {
      return [
        {
          text: i18n.t("Stock.Fields.stock_code"),
          align: "start",
          sortable: false,
          value: "stock_code",
        },
        {
          text: i18n.t("Stock.Fields.stock_name"),
          align: "start",
          sortable: false,
          value: "stock_name",
        },
        {
          text: i18n.t("Stock.Fields.type"),
          align: "center",
          sortable: false,
          value: "stock_type",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "actions",
        },
      ];
    },
    orderRulerHeaders() {
      return [
        {
          text: i18n.t("MaterialOrderRule.Fields.rule_name"),
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.rule_type"),
          align: "start",
          sortable: false,
          value: "type",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "actions",
        },
      ];
    },
    shopPsiUrl() {
      return (
        this.$ShopPsiUrl +
        this.accessToken +
        "/?account_id=" +
        this.accountInfo.account_id +
        "&account_user_id=" +
        this.accountUser.id +
        "&shop_id=" +
        this.shop.id
      );
    },
    templatesItems() {
      return this.templates.map((template) => {
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == template.id
            )
          : false;
        return Object.assign({}, template, { disabled });
      });
    },
    presellTemplatesItems() {
      return this.presellTemplates.map((template) => {
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == template.id
            )
          : false;
        return Object.assign({}, template, { disabled });
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState([
      "accessToken",
      "accountInfo",
      "accountUser",
      "loading",
      "citiesMap",
      "settings",
      "sync_shop_data_from",
    ]),
  },

  data: () => ({
    tab: null,
    shop: {},
    shopAddresses: [],
    allianceBusinessShops: [],
    stockDistributionConfigs: [],
    stockDistributionPaging: {},
    stockDistributionOptions: {},
    orderRulers: [],
    shopUsers: [],
    sub_account_type_arr: [],
    sub_account_arr: [],
    shop_user: {},
    contract_period: [],
    show1: false,
    serverErrors: [],
    addressServerErrors: [],
    userServerErrors: [],
    testData: [
      // {
      //   id: "1",
      //   name: "TODO",
      // },
      // {
      //   id: "2",
      //   name: "TODO",
      // },
      // {
      //   id: "3",
      //   name: "TODO",
      // },
      // {
      //   id: "4",
      //   name: "TODO",
      // },
      // {
      //   id: "5",
      //   name: "TODO",
      // },
    ],
    provinceSelected: null,
    citySelected: null,
    districtSelected: null,
    provinceItemsObj: null,
    cityItemsObj: null,
    districtItemsObj: null,
    currentItem: {},
    editDialog: false,
    deleteDialog: false,
    addPsiDateDialog: false,
    addPsiDate: "",
    addPsiDateErrors: [],
    currentUserItem: {},
    editUserDialog: false,
    deleteUserDialog: false,
    settingDefaultAddressDialog: false,
    settingDefaultAddressMsg: "",
    settingDefaultAddressDetail: null,
    orderCycles: [],
    editSubAccountPercentDialog: false,
    materialTemplate: null,
    presellTemplate: null,
    templates: [],
    templatesLoading: false,
    presellTemplatesLoading: false,
    templatesSearch: "",
    presellTemplatesSearch: "",
    subAccounts: [],
    shop_sub_account_name: "",
    labels: [],
    avatar_img: "",
    avatar_img_file: null,
    imgRules: [
      (value) =>
        !value || value.size < 5000000 || i18n.t("Material.imgSquareHint"),
    ],
    service_charge_type: 0,
    relations: [],
    freeMaterials: [],
    materials_dialog: false,
    alertDialog: false,
    presellTemplates: [],
    Dialog: false,
    dataItem: null,
    materialsDialog: false,
    shopId: null,
    stockId:null
  }),

  mounted() {
    //获取分账类型
    SubAccountSettings.fetchAll().then(
      function (response) {
        if (response.data.status.isOK()) {
          if (response.data.sub_account_settings) {
            for (let key in response.data.sub_account_settings) {
              this.sub_account_type_arr.push(
                Object.assign({}, response.data.sub_account_settings[key], {
                  code: key,
                  sub_account_id: "",
                })
              );
              this.sub_account_arr = JSON.parse(
                JSON.stringify(this.sub_account_type_arr)
              );
            }
          }
        }
      }.bind(this)
    );
  },

  methods: {
    submit() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            var shop = JSON.parse(JSON.stringify(this.shop));
            if (this.$refs.label) shop.label = this.$refs.label.lazySearch;
            if (shop.district && shop.district.code) {
              shop.city_1 = this.shop.district.code;
            }
            if (this.materialTemplate != null) {
              shop.material_template_id = this.materialTemplate;
            }
            if (this.presellTemplate != null) {
              shop.presale_template_id = this.presellTemplate;
            }
            delete shop.district;
            delete shop.template;
            shop.shop_user = this.shop_user;

            if (this.sub_account_arr.length) {
              let json = {};
              this.sub_account_arr.forEach((s) => {
                if (s.sub_account_id) {
                  json[s.code] = { sub_account_id: s.sub_account_id };
                }
              });
              shop.sub_account_json = Object.keys(json).length ? json : null;
            }

            Shops.save(this.shop.id, shop)
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$emit("save", shop);
                    this.$emit("mode", null);
                    this.$emit("input", null);
                    this.$refs.observer.reset();
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.serverErrors = response.data.error.data;
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    changeDefaultAddress(item) {
      if (item.default_flg) {
        this.settingDefaultAddressDetail = item;
        this.settingDefaultAddressMsg = i18n.t(
          "Shop.settingDefaultShopAddress",
          [item.address]
        );
        this.settingDefaultAddressDialog = item.default_flg == 1;
      }
    },
    settingDefaultAddress() {
      if (this.settingDefaultAddressDetail) {
        this.settingDefaultAddressDetail.default_flg = 1;
        ShopAddress.save(
          this.settingDefaultAddressDetail.id,
          this.settingDefaultAddressDetail
        ).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getShopAddressFromAPI();
            }
          }.bind(this)
        );
      }
    },
    saveShopAddress() {
      if (this.currentItem) {
        this.$store.dispatch("fullscreenLoading");
        this.$refs.addressObserver.validate().then(
          function (result) {
            if (result) {
              ShopAddress.save(this.currentItem.id, this.currentItem).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.getShopAddressFromAPI();
                    this.$refs.addressObserver.reset();
                    this.editDialog = false;
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.addressServerErrors = response.data.error.data;
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
            } else {
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        );
      }
    },
    saveShopUser() {
      if (this.currentUserItem) {
        this.$store.dispatch("fullscreenLoading");
        this.$refs.userObserver.validate().then(
          function (result) {
            if (result) {
              ShopUsers.save(
                this.currentUserItem.id,
                this.currentUserItem
              ).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.getShopUsersFromAPI();
                    this.$refs.userObserver.reset();
                    this.editUserDialog = false;
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.userServerErrors = response.data.error.data;
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
            } else {
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        );
      }
    },
    saveAddPsiDate() {
      if (this.addPsiDate) {
        this.$store.dispatch("fullscreenLoading");
        this.$refs.psiObserver.validate().then(
          function (result) {
            if (result) {
              Shops.addPsiDate({
                shop_id: this.shop.id,
                lifespan_days: this.addPsiDate,
              }).then((response) => {
                if (response.data.status.isOK()) {
                  this.$refs.psiObserver.reset();
                  this.addPsiDateDialog = false;
                  this.addPsiDate = "";
                  this.getShopFromApI(this.shop.id);
                } else if (
                  response.data.error &&
                  response.data.error.data &&
                  "ERR333" == response.data.error.code
                ) {
                  this.addPsiDateErrors = response.data.error.data;
                }
                this.$store.dispatch("fullscreenLoadingStop");
              });
            } else {
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        );
      }
    },
    deleteShopAddress() {
      if (this.currentItem && this.currentItem.id) {
        ShopAddress.del(this.currentItem.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getShopAddressFromAPI();
            }
          }.bind(this)
        );
      }
    },
    deleteShopUser() {
      if (this.currentUserItem && this.currentUserItem.id) {
        ShopUsers.del(this.currentUserItem.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getShopUsersFromAPI();
            }
          }.bind(this)
        );
      }
    },
    getShopAddressFromAPI() {
      ShopAddress.fetchByShop({ shop_id: this.value.id }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shopAddresses = response.data.shop_address;
          }
        }.bind(this)
      );
    },
    getAllianceBusinessFromAPI() {
      Shops.getAllianceBusinesses({
        shop_id: this.value.id,
        limit: this.$consts.limitAll,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.allianceBusinessShops = response.data.alliance_business_shops;
          }
        }.bind(this)
      );
    },
    getSockDistributionConfigs() {
      Shops.getSockDistributionConfigs(Object.assign(this.stockDistributionOptions,{
        shop_id: this.value.id,
      })).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stockDistributionConfigs = response.data.stocks;
            this.stockDistributionPaging = response.data.paging
          }
        }.bind(this)
      );
    },
    getOrderRulers() {
      Shops.getOrderRulers({shop_id: this.value.id}).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.orderRulers = response.data.order_rulers;
            }
          }.bind(this)
      );
    },
    getOrderRulerType(data) {
      switch (data) {
        case 1:
          return i18n.t("MaterialOrderRule.minOrderRule.title")
        case 2:
          return i18n.t("MaterialOrderRule.numberMatchRule.title")
        case 3:
          return i18n.t("MaterialOrderRule.maxOrderRule.title")
        case 4:
          return i18n.t("MaterialOrderRule.minOrderMoneyRule.title")
        case 5:
          return i18n.t("MaterialOrderRule.autoStandardRule.title")
        case 6:
          return i18n.t("MaterialOrderRule.mixProductRule.title")
        case 7:
          return i18n.t("MaterialOrderRule.expressFee.title")
        case 9:
          return i18n.t("MaterialOrderRule.forceOrderRule.title")
      }
    },
    getOrderRulerDetailUrl(data) {
      switch (data) {
        case 1:
          return "material-order-rules/min_quantity/"
        case 2:
          return "material-order-rules/quantity/"
        case 3:
          return "material-order-rules/max_quantity/"
        case 4:
          return "material-order-rules/min_amount/"
        case 5:
          return "material-order-rules/auto/"
        case 6:
          return "material-order-rules/combine_material/"
        case 7:
          return "material-order-rules/express_fee/"
        case 9:
          return "material-order-rules/force-order/"
      }
    },
    getShopUsersFromAPI() {
      ShopUsers.fetchByShop(this.value.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shopUsers = response.data.shop_user;
          }
        }.bind(this)
      );
    },
    checkShopPsiOpenFromAPI() {
      Shops.checkShopPsiOpen().then(
        function (response) {
          if (!response.data.status.isOK()) {
            this.shop.old_psi_enable = true;
            this.shop.psi_enable = 0;
          }
        }.bind(this)
      );
    },
    getShopFromApI(id) {
      Shops.fetchOne(id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shop = response.data.shop;
            this.avatar_img = this.shop.avatar_img_url;
            if (
              this.subAccounts.length &&
              this.settings &&
              this.settings.sub_account_enable == 2
            ) {
              this.subAccounts.forEach((subAccount) => {
                if (subAccount.id == this.shop.shop_sub_account_id) {
                  this.shop_sub_account_name = subAccount.account_name;
                }
              });
            }
            if (this.shop.shop_sub_account_id) {
              this.shop.shop_sub_account_id = Number(
                this.shop.shop_sub_account_id
              );
            }

            if (
              this.shop.material_template_id == null ||
              this.shop.material_template_id == "null"
            ) {
              this.materialTemplate = 0;
            } else {
              this.materialTemplate = this.shop.material_template_id;
            }
            if (
              this.shop.presale_template_id == null ||
              this.shop.presale_template_id == "null"
            ) {
              this.presellTemplate = 0;
            } else {
              this.presellTemplate = this.shop.presale_template_id;
            }

            if (!this.shop.template)
              this.shop.template = { id: this.shop.material_template_id };
            if (this.shop.shop_user) {
              this.shop_user = JSON.parse(JSON.stringify(this.shop.shop_user));
            }
            this.shop.old_psi_enable = this.shop.psi_enable;
            this.contract_period = [
              this.shop.contract_start,
              this.shop.contract_end,
            ];
            if (!this.shop.weQrCode_url) {
              Shops.getWxQrCode(this.shop.id).then(
                function (res) {
                  if (res.data.status.isOK()) {
                    this.shop.weQrCode_url = res.data.data.img_url;
                  }
                }.bind(this)
              );
            }
            if (this.settings && this.settings.service_charge_enable) {
              this.service_charge_type = this.shop.service_charge_type;
            }
            this.getTemplatesFromAPI(this.shop.material_template_id);
          }
        }.bind(this)
      );
    },
    getTemplatesFromAPI(selectedId = "") {
      this.templatesLoading = true;
      Templates.fetchAllForSelect({ selected: selectedId })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.templates = response.data.templates;
            }
            this.templatesLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.templatesLoading = false;
          }.bind(this)
        );
    },
    getPresellTemplatesFromAPI() {
      this.presellTemplatesLoading = true;
      PresaleTemplates.fetch()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.presellTemplates = response.data.presale_templates;
            }
            this.presellTemplatesLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.presellTemplatesLoading = false;
          }.bind(this)
        );
    },
    getSubAccountsFromAPI() {
      SubAccounts.fetchAllForSelect().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.subAccounts = response.data.sub_accounts;
            if (
              this.shop.length &&
              this.settings &&
              this.settings.sub_account_enable == 2
            ) {
              this.subAccounts.forEach((subAccount) => {
                if (subAccount.id == this.shop.shop_sub_account_id) {
                  this.shop_sub_account_name = subAccount.account_name;
                }
              });
            }
          }
        }.bind(this)
      );
    },
    getLabelsFromAPI() {
      Shops.fetchLabels().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.labels = response.data.label;
          }
        }.bind(this)
      );
    },
    getServiceChargeSettingFromAPI(id) {
      Shops.viewFreeMaterials(id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.freeMaterials = [];
            this.relations = response.data.relations;
            this.relations.forEach((detail) => {
              this.freeMaterials.push(detail.material);
            });
          }
        }.bind(this)
      );
    },

    saveServiceChargeSetting(materials) {
      this.$store.dispatch("fullscreenLoading");
      var data = {
        id: this.value.id,
        service_charge_type: this.service_charge_type,
      };
      if (this.service_charge_type == 2) {
        var ids = materials.map((detail) => detail.id);
        if (materials.length == 0) {
          data = Object.assign({}, data, { empty_relation_flg: 1 });
        }
        data = Object.assign({}, data, { free_relations: ids });
      }
      Shops.serviceChargeSetting(data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(i18n.t("Shop.saveSuccess"));
            this.getServiceChargeSettingFromAPI(this.value.id);
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    syncAddress() {
      this.$store.dispatch("fullscreenLoading");
      ShopAddress.syncAddress({ shop_id: this.shop.id }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(i18n.t("Shop.saveSuccess"));
            this.getShopAddressFromAPI();
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    queryAccountInfo() {
      this.$store.dispatch("fullscreenLoading");
      Payment.queryAccountInfo({
        account_no: this.shop.shop_user.ext_code,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.dataItem = response.data.result;
            this.Dialog = true;
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
  },

  watch: {
    // mode: {
    //   immediate: true, //初始赋值也调用
    //   handler() {
    //     if (this.savable) {
    //       console.log("3")
    //       //获取分账类型
    //       SubAccountSettings.fetchAll().then(
    //         function (response) {
    //           if (response.data.status.isOK()) {
    //             if (response.data.sub_account_settings) {
    //               for (let key in response.data.sub_account_settings) {
    //                 this.sub_account_arr.push(
    //                   Object.assign({}, response.data.sub_account_settings[key], {
    //                     sub_account_id: "",
    //                   })
    //                 );
    //               }
    //             }
    //           }
    //         }.bind(this)
    //       );
    //     } else {
    //       this.sub_account_arr = []
    //     }
    //   }
    // },
    isView: {
      immediate: true, //初始赋值也调用
      handler() {
        if (!this.isView) this.tab = 0;
      },
    },
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.tab = 0;
        this.serverErrors = []; //重置远端错误提示
        this.shop_user = {};
        this.freeMaterials = [];
        this.getLabelsFromAPI();
        if (this.value && this.value.id) {
          //门店详情
          this.getShopFromApI(this.value.id);
          this.getSubAccountsFromAPI();
          this.getSockDistributionConfigs();
          if (this.$permission.permissionAllow("Shops", "getAllianceBusinesses")) {
            this.getAllianceBusinessFromAPI();
          }
          //门店多地址
          if (this.$permission.permissionAllow("ShopAddress", "view"))
            this.getShopAddressFromAPI();
          //门店多用户
          if (this.settings.shop_multiple_account) this.getShopUsersFromAPI();

          //门店要货规则
          if (this.$permission.permissionAllow("Shops", "getOrderRulers")) {
            this.getOrderRulers()
          }

          // 下单周期
          if (this.settings && this.settings.use_ordercycle) {
            OrderCycles.fetchAllForSelect().then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.orderCycles = response.data.order_cycles;
                }
              }.bind(this)
            );
          }
          if (this.settings && this.settings.service_charge_enable) {
            this.getServiceChargeSettingFromAPI(this.value.id);
          }
        } else {
          // 新建门店，初始化默认值
          this.shop = {
            status: 1,
            province_id: 0,
            province_name: "",
            city_id: 0,
            city_name: "",
            area_id: 0,
            area_name: "",
            material_template_id: 0,
            template: { id: 0 },
            shop_user: {},
            avatar_img: "",
          };
          this.avatar_img = "";
          this.avatar_img_file = null;
          this.materialTemplate = null;
          this.presellTemplate = null;
          this.getTemplatesFromAPI();
          if (
            this.$permission.permissionAllow("PresaleTemplates", "index") &&
            this.settings &&
            this.settings.presale_enable
          ) {
            this.getPresellTemplatesFromAPI();
          }
        }
        this.$scrollTop(); //返回顶部
      },
    },
    avatar_img: {
      handler() {
        if (!this.avatar_img) {
          this.avatar_img_file = null;
        }
      },
    },
    avatar_img_file: {
      handler() {
        if (this.avatar_img_file) {
          this.isUploading = true;
          // 检查一下图片上传的error，拒绝上传
          if (this.$refs.avatar_img_file.hasError) {
            this.isUploading = false;
            return;
          }
          Files.imageUpload(this.avatar_img_file, false, "shop_avatar")
            .then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.shop.avatar_img = response.data.data.img_name;
                  this.avatar_img = response.data.data.img_url;
                  this.isUploading = false;
                  this.avatar_img_file = null;
                }
              }.bind(this)
            )
            .catch(
              function () {
                this.isUploading = false;
              }.bind(this)
            );
        }
      },
    },
    editDialog: {
      handler() {
        this.addressServerErrors = []; //重置远端错误提示
        this.$refs.addressObserver.reset();
      },
    },
    shop: {
      handler() {
        //分账配置
        if (this.shop.sub_account_json && this.sub_account_arr.length) {
          this.sub_account_arr = this.sub_account_arr.map((sub) => {
            if (this.shop.sub_account_json[sub.code]) {
              sub.sub_account_id =
                this.shop.sub_account_json[sub.code].sub_account_id;
            }
            return sub;
          });
        } else {
          // 恢复默认
          this.sub_account_arr = JSON.parse(
            JSON.stringify(this.sub_account_type_arr)
          );
        }
      },
    },
    contract_period: {
      handler() {
        if (this.contract_period && this.contract_period.length == 2) {
          this.shop.contract_start = this.contract_period[0];
          this.shop.contract_end = this.contract_period[1];
        }
      },
    },
    editUserDialog: {
      handler() {
        if (!this.editUserDialog) {
          this.userServerErrors = [];
          this.$refs.userObserver.reset();
        }
      },
    },
    addPsiDateDialog: {
      handler() {
        if (!this.addPsiDateDialog) {
          this.addPsiDate = "";
          this.addPsiDateErrors = [];
          this.$refs.psiObserver.reset();
        }
      },
    },
    stockDistributionOptions: {
      handler() {
        this.getSockDistributionConfigs()
       }
    }
  },
};
</script>